import { Box, Flex, Skeleton, SkeletonText } from "@chakra-ui/react";

interface BaseTableSkeletonProps {
  rows?: number;
  columns?: number;
  showHeader?: boolean;
  maxHeight?: string;
  minHeight?: string;
}

export const BaseTableSkeleton = ({ rows = 10, columns = 8, showHeader = true, maxHeight = "68vh", minHeight = "500px" }: BaseTableSkeletonProps) => {
  return (
    <>
      <Box backgroundColor="white" maxH={maxHeight} border="1px solid #e1e7ef" borderRadius="8px" boxShadow="sm" overflow="hidden">
        <Box
          style={{
            minWidth: "max-content",
            width: "100%",
          }}
        >
          {showHeader && (
            <Box borderBottom="1px solid #e1e7ef" backgroundColor="#f8f9fa" padding="16px">
              <Flex gap="16px">
                {Array.from({ length: columns }).map((_, index) => (
                  <Skeleton
                    key={index}
                    height="20px"
                    width={
                      index === 0
                        ? "40px" // Checkbox column
                        : index === 1
                          ? "150px" // Name column
                          : index === 2
                            ? "120px" // Position column
                            : index === 3
                              ? "250px" // Skills column (wider)
                              : "100px" // Other columns
                    }
                    borderRadius="4px"
                  />
                ))}
              </Flex>
            </Box>
          )}

          <Box>
            {Array.from({ length: rows }).map((_, rowIndex) => (
              <Box key={rowIndex} borderBottom="1px solid #e1e7ef" padding="16px" _hover={{ backgroundColor: "#f8f9fa" }}>
                <Flex gap="16px" alignItems="center">
                  {Array.from({ length: columns }).map((_, colIndex) => {
                    // Первая колонка - чекбокс
                    if (colIndex === 0) {
                      return <Skeleton key={colIndex} height="16px" width="16px" borderRadius="2px" />;
                    }

                    // Колонка навыков - специальный скелетон с тегами
                    if (colIndex === 3) {
                      return (
                        <Flex key={colIndex} gap="4px" flexWrap="wrap" width="250px">
                          <Skeleton height="24px" width="60px" borderRadius="12px" />
                          <Skeleton height="24px" width="80px" borderRadius="12px" />
                          <Skeleton height="24px" width="45px" borderRadius="12px" />
                        </Flex>
                      );
                    }

                    // Остальные колонки - обычный текст
                    return (
                      <SkeletonText
                        key={colIndex}
                        noOfLines={1}
                        spacing="4"
                        width={
                          colIndex === 1
                            ? "150px" // Name column
                            : colIndex === 2
                              ? "120px" // Position column
                              : colIndex === 4
                                ? "100px" // Telegram column
                                : colIndex === 5
                                  ? "120px" // Status column
                                  : colIndex === 6
                                    ? "100px" // Created by column
                                    : "80px" // Date column
                        }
                      />
                    );
                  })}
                </Flex>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </>
  );
};
